<ng-container [matColumnDef]="columnKeyName">
    <mat-header-cell *matHeaderCellDef>
        <div class="full-height full-width flex-column flex-center-start">
            @if (sortable) {
            <p
                class="column-title unselectable"
                mat-sort-header
            >
                {{ title }}
            </p>
            } @if (!sortable) {
            <p class="column-title unselectable">{{ title }}</p>
            } @if (!entityBrowser.hideFilters) {
            <mat-form-field
                class="full-width"
                appearance="outline"
                [hideRequiredMarker]="false"
                [floatLabel]="'auto'"
            >
                <mat-select
                    [(value)]="Filter"
                    [panelClass]="'select-column'"
                    #tooltip="matTooltip"
                    (selectionChange)="onValueChanged($event)"
                    [matTooltip]="tooltipSelect"
                    [matTooltipDisabled]="entityBrowser.disableTooltip"
                    (mouseover)="entityBrowser.checkInputClientVisibility($event, tooltip, '.mat-mdc-select-value')"
                    [disabled]="disabled"
                    disableOptionCentering
                    id="{{ selectorId }}"
                    [(ngModel)]="Filter"
                    (ngModelChange)="onFilterChange()"
                    [multiple]="allowMultiple"
                    [placeholder]="allowMultiple ? 'Select a value' : ''"
                >
                    @if (hasSearchFilter) {
                    <mat-form-field
                        class="search-dropdown"
                        appearance="outline"
                    >
                        <label>
                            <input
                                matInput
                                type="text"
                                autocomplete="off"
                                i18n-placeholder
                                placeholder="Search"
                                #selectorSearch
                                [(ngModel)]="SearchFilter"
                                (ngModelChange)="onSearchChanged(SearchFilter)"
                            />
                        </label>
                        @if (SearchFilter) {
                        <button
                            matSuffix
                            mat-icon-button
                            (click)="onSearchChanged('')"
                            class="inline-block"
                        >
                            <mat-icon>close</mat-icon>
                        </button>
                        } @if (!SearchFilter) {
                        <button
                            matSuffix
                            mat-icon-button
                            disabled
                            class="inline-block"
                        >
                            <mat-icon>search</mat-icon>
                        </button>
                        }
                    </mat-form-field>
                    }
                    <section>
                        @if (!allowMultiple) {
                        <mat-option
                            class="column-select-option"
                            [value]="''"
                            >All
                        </mat-option>
                        } @if (customOption) {
                        <mat-option
                            class="column-select-option"
                            [value]="'open'"
                            >{{ customOption }}
                        </mat-option>
                        } @for (option of getOptions() | async; track option) {
                        <mat-option
                            class="column-select-option {{ optionsClassName }}"
                            [value]="getOption(option)"
                        >
                            {{ getOptionText(option) }}
                        </mat-option>
                        }
                    </section>
                </mat-select>
                @if (!allowMultiple) {
                <button
                    matSuffix
                    mat-icon-button
                    [style.visibility]="Filter === null || Filter === undefined || Filter === '' ? 'hidden' : 'visible'"
                    (click)="clearFilter($event)"
                >
                    <mat-icon>close</mat-icon>
                </button>
                }
            </mat-form-field>
            }
        </div>
    </mat-header-cell>

    @if (cellTemplate) {
    <div>
        <mat-cell *matCellDef="let entity">
            <ng-container *ngTemplateOutlet="cellTemplate; context: { $implicit: entity }"></ng-container>
        </mat-cell>
    </div>
    } @else {
    <ng-template #defaultCell>
        <mat-cell *matCellDef="let entity">
            <p
                class="text-ellipsis"
                #tooltip="matTooltip"
                [matTooltip]="getOptionText(getEntityProperty(entity))"
                [matTooltipDisabled]="entityBrowser.disableTooltip"
                (mouseover)="entityBrowser.checkInputClientVisibility($event, tooltip)"
            >
                {{ getOptionText(getEntityProperty(entity)) }}
            </p>
        </mat-cell>
    </ng-template>
    }
</ng-container>
